import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { ISODate } from '../../../common/utils';
import { AlgorithmUrl } from './AlgorithmUrl';
import { AlgorithmExtendedType } from '../schema/types';
import { AlgorithmExtendedSchema } from '../schema/AlgorithmExtendedSchema';
import { useCallback } from 'react';
import { Query, useQueryClient } from '@tanstack/react-query';

export interface AlgorithmFilter {
  search?: string;
  statusCodes?: string[];
  validFrom?: ISODate;
  validTo?: ISODate;
  indicatorIds?: number[];
  dimensionIds?: number[];
  dimensionCategoryIds?: number[];
}

interface AlgorithmsQueryParams extends AlgorithmFilter {
  dataObjectVersionId: number;
  isAlgorithmView: boolean;
}

const getAlgorithms = (params?: AlgorithmsQueryParams) =>
  apiClient
    .get<AlgorithmExtendedType[]>(expand(AlgorithmUrl.base, params))
    .then((response) => AlgorithmExtendedSchema.array().parse(response.data));

export const useListAlgorithmsQuery = createApiQueryHook(
  ['data-object-algorithms'],
  getAlgorithms,
);

export const useRefetchListAlgorithms = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.refetchQueries({
        predicate: (query: Query) =>
          query.queryKey.toString().includes('data-object-algorithms'),
      }),
    [queryClient],
  );
};
